import { action } from 'mobx'
import axios from "axios/index";
import {Common as util} from "../utils/common";
import gql from "../utils/gql";
// const SINGIN = gql`
// query signIn ($emailId: String!, $password: String!) {
//         signIn(emailId: $emailId, password: $password) {
//         name email token rfToken
//     }
// }`;

export class Booster {

    @action getBoosterSetting = (data, cb) => {

        let property = ['store_id', 'shopNo']
        let variables = util.getDataStByKey(data, property);

        let params = {
            type: 'query',
            operation: 'getBoosterSetting',
            variables: variables,
            getData: 'data'
        };

        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(res.status === 200) {
                    if(typeof cb === 'function') {
                        if(res.data.errors && res.data.errors.length > 0) {
                            //cb(res.data);
                        }
                        else {
                            cb(res.data.data[params.operation]);
                        }

                    }
                    else {
                        return res.data.data[params.operation];
                    }
                }

            })
            .catch(function (error) {
                console.log(error);
                return error;
            });
    };

    // 알림톡 경유 작성 리뷰의 시간대(0~23시) 분포 — 발송 시간대 설정 참고용
    @action getAlimReviewHourStats = (data, cb) => {

        let property = ['store_id', 'shopNo']
        let variables = util.getDataStByKey(data, property);

        let params = {
            type: 'query',
            operation: 'getAlimReviewHourStats',
            variables: variables,
            getData: 'data'
        };

        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(res.status === 200) {
                    if(typeof cb === 'function') {
                        if(res.data.errors && res.data.errors.length > 0) {
                            // 구버전 API(쿼리 미배포) 등 — 조용히 무시 (참고용 보조 데이터)
                        }
                        else {
                            cb(res.data.data[params.operation]);
                        }
                    }
                    else {
                        return res.data.data[params.operation];
                    }
                }
            })
            .catch(function (error) {
                console.log(error);
                return error;
            });
    };

    // 메인 상품 진열 (주문유도) — 진열 속성 조회 (GET /admin/mains/properties)
    @action getCafe24MainProperties = (data, cb) => {

        let property = ['store_id', 'shopNo', 'displayGroup']
        let variables = util.getDataStByKey(data, property);

        let params = {
            type: 'query',
            operation: 'getCafe24MainProperties',
            variables: variables,
            getData: 'data'
        };

        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(res.status === 200) {
                    if(typeof cb === 'function') {
                        if(res.data.errors && res.data.errors.length > 0) {
                            cb({ errors: res.data.errors });
                        }
                        else {
                            cb(res.data.data[params.operation]);
                        }
                    }
                    else {
                        return res.data.data[params.operation];
                    }
                }

            })
            .catch(function (error) {
                console.log(error);
                if(typeof cb === 'function') {
                    cb({ errors: [{ message: error.message }] });
                }
                return error;
            });
    };

    // 메인 상품 진열 — 사용자 속성 추가 (POST /admin/mains/properties)
    @action addCafe24MainProperty = (data, cb) => {

        let property = ['store_id', 'shopNo', 'property']
        let variables = util.getDataStByKey(data, property);

        let params = {
            type: 'mutation',
            operation: 'addCafe24MainProperty',
            variables: variables,
            getData: 'data'
        };

        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(res.status === 200) {
                    if(typeof cb === 'function') {
                        if(res.data.errors && res.data.errors.length > 0) {
                            cb({ errors: res.data.errors });
                        }
                        else {
                            cb(res.data.data[params.operation]);
                        }
                    }
                    else {
                        return res.data.data[params.operation];
                    }
                }

            })
            .catch(function (error) {
                console.log(error);
                if(typeof cb === 'function') {
                    cb({ errors: [{ message: error.message }] });
                }
                return error;
            });
    };

    // 메인 상품 진열 — 속성 수정 (PUT /admin/mains/properties)
    @action updateCafe24MainProperties = (data, cb) => {

        let property = ['store_id', 'shopNo', 'displayGroup', 'properties']
        let variables = util.getDataStByKey(data, property);

        let params = {
            type: 'mutation',
            operation: 'updateCafe24MainProperties',
            variables: variables,
            getData: 'data'
        };

        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(res.status === 200) {
                    if(typeof cb === 'function') {
                        if(res.data.errors && res.data.errors.length > 0) {
                            cb({ errors: res.data.errors });
                        }
                        else {
                            cb(res.data.data[params.operation]);
                        }
                    }
                    else {
                        return res.data.data[params.operation];
                    }
                }

            })
            .catch(function (error) {
                console.log(error);
                if(typeof cb === 'function') {
                    cb({ errors: [{ message: error.message }] });
                }
                return error;
            });
    };

    // 메인 상품 진열 — gql 호출 공통 처리 (cafe24 프록시 계열 액션용)
    _callCafe24Op = (type, operation, variables, cb) => {

        let params = {
            type: type,
            operation: operation,
            variables: variables,
            getData: 'data'
        };

        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(res.status === 200) {
                    if(typeof cb === 'function') {
                        if(res.data.errors && res.data.errors.length > 0) {
                            cb({ errors: res.data.errors });
                        }
                        else {
                            cb(res.data.data[params.operation]);
                        }
                    }
                    else {
                        return res.data.data[params.operation];
                    }
                }

            })
            .catch(function (error) {
                console.log(error);
                if(typeof cb === 'function') {
                    cb({ errors: [{ message: error.message }] });
                }
                return error;
            });
    };

    // 인기상품 메인진열 적용/미리보기 — dryRun: true 면 산출/diff 만, false 면 실제 적용
    @action applyPopularDisplay = (data, cb) => {
        let property = ['store_id', 'shopNo', 'dryRun', 'configOverride']
        let variables = util.getDataStByKey(data, property);
        return this._callCafe24Op('mutation', 'applyPopularDisplay', variables, cb);
    };

    // 메인 진열 그룹 추가 (POST /admin/mains)
    @action addCafe24MainDisplayGroup = (data, cb) => {
        let property = ['store_id', 'shopNo', 'groupName']
        let variables = util.getDataStByKey(data, property);
        return this._callCafe24Op('mutation', 'addCafe24MainDisplayGroup', variables, cb);
    };

    // 메인진열 등록 상품 조회 (GET /admin/mains/{display_group}/products)
    @action getCafe24MainProducts = (data, cb) => {
        let property = ['store_id', 'shopNo', 'displayGroup']
        let variables = util.getDataStByKey(data, property);
        return this._callCafe24Op('query', 'getCafe24MainProducts', variables, cb);
    };

    // 메인진열 상품 추가 (POST /admin/mains/{display_group}/products)
    @action addCafe24MainProducts = (data, cb) => {
        let property = ['store_id', 'shopNo', 'displayGroup', 'productNos']
        let variables = util.getDataStByKey(data, property);
        return this._callCafe24Op('mutation', 'addCafe24MainProducts', variables, cb);
    };

    // 메인진열 상품 수정 — 진열 순서/고정 (PUT /admin/mains/{display_group}/products)
    @action updateCafe24MainProducts = (data, cb) => {
        let property = ['store_id', 'shopNo', 'displayGroup', 'productNos', 'fixProductNos']
        let variables = util.getDataStByKey(data, property);
        return this._callCafe24Op('mutation', 'updateCafe24MainProducts', variables, cb);
    };

    // 메인진열 상품 삭제 (DELETE /admin/mains/{display_group}/products/{product_no})
    @action deleteCafe24MainProduct = (data, cb) => {
        let property = ['store_id', 'shopNo', 'displayGroup', 'productNo']
        let variables = util.getDataStByKey(data, property);
        return this._callCafe24Op('mutation', 'deleteCafe24MainProduct', variables, cb);
    };

    // 인기 제품 분석 (주문유도) — 기간 내 상품별 주문수/리뷰수/평균평점 원시 지표 조회
    // fillTopN: 풀이 부족하면 전체기간 리뷰 기준 폴백으로 채움 (인기상품 메인진열 미리보기용)
    @action getPopularProducts = (data, cb) => {

        let property = ['store_id', 'shopNo', 'startDate', 'endDate', 'fillTopN']
        let variables = util.getDataStByKey(data, property);

        let params = {
            type: 'query',
            operation: 'getPopularProducts',
            variables: variables,
            getData: 'data'
        };

        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(res.status === 200) {
                    if(typeof cb === 'function') {
                        if(res.data.errors && res.data.errors.length > 0) {
                            cb({ errors: res.data.errors });
                        }
                        else {
                            cb(res.data.data[params.operation]);
                        }
                    }
                    else {
                        return res.data.data[params.operation];
                    }
                }

            })
            .catch(function (error) {
                console.log(error);
                if(typeof cb === 'function') {
                    cb({ errors: [{ message: error.message }] });
                }
                return error;
            });
    };

    @action setBoosterSetting = (data, cb) => {


        let params = {
            type: 'mutation',
            operation: 'setBoosterSetting',
            variables: data,
            getData: 'data'
        };

        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(res.status === 200) {
                    if(typeof cb === 'function') {
                        cb(res.data.data[params.operation]);
                    }
                    else {
                        return res.data.data[params.operation];
                    }
                }

            })
            .catch(function (error) {
                console.log(error);
                return error;
            });
    };
    @action removeKakaoTemp = (data, cb) => {


        let params = {
            type: 'mutation',
            operation: 'removeKakaoTemp',
            variables: data,
            getData: 'data'
        };

        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(res.status === 200) {
                    if(typeof cb === 'function') {
                        cb(res.data.data[params.operation]);
                    }
                    else {
                        return res.data.data[params.operation];
                    }
                }

            })
            .catch(function (error) {
                console.log(error);
                return error;
            });
    };


    @action setKakaoTemp = (data, cb) => {


        let params = {
            type: 'mutation',
            operation: 'setKakaoTemp',
            variables: data,
            getData: 'data'
        };

        const gpqParams = gql(params);
        gpqParams.query = gpqParams.query.replaceAll("\n", "\\n")

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(res.status === 200) {
                    if(typeof cb === 'function') {
                        cb(res.data.data[params.operation]);
                    }
                    else {
                        return res.data.data[params.operation];
                    }
                }

            })
            .catch(function (error) {
                console.log(error);
                return error;
            });
    };





    @action sendTestKakao = (data, cb) => {

        let params = {
            type: 'mutation',
            operation: 'sendTestKakao',
            variables: data,
            getData: 'data'
        };

        const gpqParams = gql(params);

        return axios.post('/', gpqParams)
            .then(function (res) {
                if(res.status === 200) {
                    if(typeof cb === 'function') {
                        cb(res.data.data[params.operation]);
                    }
                    else {
                        return res.data.data[params.operation];
                    }
                }
            })
            .catch(function (error) {
                console.log(error);
                if(typeof cb === 'function') {
                    cb({ errors: [{ message: '테스트 발송 요청 중 오류가 발생했습니다.' }] });
                }
                return error;
            });
    };

    @action addKakaoProfile = (data, cb) => {
        //data.kakaoPlusid = data.plusid;
        let property = ['store_id', 'shopNo', 'kakaoPlusid', 'phonenumber', 'authnum', 'categorycode']
        let variables = util.getDataStByKey(data, property);

        let params = {
            type: 'mutation',
            operation: 'addKakaoProfile',
            variables: variables,
            getData: 'data'
        };
        let gpqParams = gql(params);

        axios.post('/', gpqParams)
            .then(function (res) {
                let results = res.data.data[params.operation] !== null ? res.data.data[params.operation] : res.data;
                if(typeof cb === 'function') {
                    cb(results);
                }
                else {
                    return results;
                }

            })
            .catch(function (error) {
                if(typeof cb === 'function') {
                    cb(error)
                }
                return error;
            });

    };




}
